import { List } from "models/list";
import { FunctionComponent } from "react";
import SettingsListForm from "./settings-list-form";
import SettingsListTemplateForm from "./settings-list-template-form";

interface SettingsFormProps {
  list: List;
}

const SettingsForm: FunctionComponent<SettingsFormProps> = ({ list }) => {
  if (list.template) {
    return <SettingsListTemplateForm list={list} />;
  }
  return <SettingsListForm list={list} />;
};

export default SettingsForm;
